import { SEMANTIC_COLOR } from '@/shared/design-tokens/design-tokens';
import { formatHourMinute } from '@/shared/lib/format';

import type { MetricChartPodHistory, MetricChartSeriesOptionInput } from './metricChartTypes';

const METRIC_CHART_DEFAULT_LINE_COLOR = SEMANTIC_COLOR.ON_CONTAINER.COLORFUL.FUCHSIA;

export const createMetricChartSeries = (podHistory: MetricChartPodHistory[]): MetricChartSeriesOptionInput => {
  const timestampSet = new Set<number>();

  podHistory.forEach((pod) => {
    pod.data.forEach((point) => {
      timestampSet.add(point.timestamp);
    });
  });

  const sortedTimestamps = [...timestampSet].sort((a, b) => a - b);

  if (sortedTimestamps.length === 0) {
    return {
      series: [],
      xAxisLabels: [],
    };
  }

  const series = podHistory
    .map((pod) => {
      const valueByTimestamp = new Map<number, number>();

      pod.data.forEach((point) => {
        valueByTimestamp.set(point.timestamp, Number(point.value.toFixed(2)));
      });

      const data = sortedTimestamps.map((timestamp) => {
        const value = valueByTimestamp.get(timestamp);
        return typeof value === 'number' && Number.isFinite(value) ? value : null;
      });
      const hasValidValue = data.some((value) => value !== null);

      if (!hasValidValue) return null;

      return {
        color: pod.color || METRIC_CHART_DEFAULT_LINE_COLOR,
        data,
        name: pod.pod,
      };
    })
    .filter((line) => line !== null);

  return {
    series,
    xAxisLabels: sortedTimestamps.map((timestamp) => formatHourMinute(timestamp)),
  };
};
